const variants = window.productData.variants;
const colorMap = {};
const fingerboardImageMap = {};
const finishCountEl = document.querySelector('.bidirectional-available-finishes');

const supportedLocales = ['en', 'es', 'fr', 'it', 'de', 'nl', 'se', 'pt', 'pl', 'ja'];
const currentLocale = supportedLocales.includes(Shopify.locale) ? Shopify.locale : 'en';
// Since this reads Shopify.locale, "ja" is used instead of "jp" for Japan.
const finishCountTranslations = {
  single: {
    'en': '1 finish available',
    'es': '1 acabado disponible',
    'fr': '1 finition disponible',
    'it': '1 finitura disponibile',
    'de': '1 Finish verfügbar',
    'nl': '1 lakafwerking beschikbaar',
    'se': 'finns i 1 finish',
    'pt': '1 acabamento disponível',
    'pl': '1 wykończenie',
    'ja': '1カラー'
  },
  multiple: {
    'en': '# finishes available',
    'es': '# acabados disponibles',
    'fr': '# finitions disponibles',
    'it': '# finiture disponibili',
    'de': '# Finishes verfügbar',
    'nl': '# lakafwerkingen beschikbaar',
    'se': 'finns i # finishar',
    'pt': '# acabamentos disponíveis',
    'pl': '# wykończenia',
    'ja': '#カラー'
  }
}

function preloadResource(url) {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = url;  
  document.head.appendChild(link);
}

// Map colors to their available fingerboards and body material.
variants.forEach(variant => {
  const color = variant.option1;
  const fingerboard = variant.option2;
  const body = variant.option3;

  if (!color || !fingerboard || !body) {
    return;
  }

  if (!colorMap[color]) {
    colorMap[color] = { fingerboards: [], body: body };
  }

  if (colorMap[color].fingerboards.indexOf(fingerboard) === -1) {
    colorMap[color].fingerboards.push(fingerboard);
  }

  if (!fingerboardImageMap[fingerboard]) {
    fingerboardImageMap[fingerboard] = {};
  }

  if (!fingerboardImageMap[fingerboard][color] && variant.featured_image.src) {
    const rotation = (variant.name.toLowerCase().includes('left')) ? 90 : 270;
    const imageUrl = `https://www.fender.com/cdn-cgi/image/format=png,fit=cover,width=120,height=185,gravity=0.5x1,background=transparent,rotate=${rotation}/https:${variant.featured_image.src}`;
    preloadResource(imageUrl);
    fingerboardImageMap[fingerboard][color] = imageUrl;
  }
});


// Return the available colors for a given body and fingerboard combination.
function getAvailableColors(bodyMaterial, fingerboardMaterial) {
  return Object.keys(colorMap).filter(color => {
    if (
      colorMap[color].fingerboards.indexOf(fingerboardMaterial) === -1 ||
      colorMap[color].body !== bodyMaterial
    ) {
      return false;
    }

    return true;
  });
}

const colorInputs = document.querySelectorAll('input[name="Color"]');
const colorLabels = document.querySelectorAll('.swatch-input__label.Color');
const bodyMaterialInputs = document.querySelectorAll('input[name="Body Material"]');
const bodyMaterialLabels = document.querySelectorAll('.swatch-input-label.Body.Material');
const fingerboardMaterialInputs = document.querySelectorAll('input[name="Fingerboard Material"]');
const fingerboardMaterialLabels = document.querySelectorAll('.swatch-input-label.Fingerboard.Material');

function applyBodyMaterialDimming(selectedBody) {
  bodyMaterialLabels.forEach(el => {
    if (selectedBody == el.title) {
      el.classList.remove('pdp-ux-swatch-dimmed');
    } else {
      el.classList.add('pdp-ux-swatch-dimmed');
    }
  });
}

function applyFingerboardMaterialDimming(selectedColor) {
  fingerboardMaterialLabels.forEach(el => {
    if (colorMap[selectedColor].fingerboards.includes(el.title)) {
      el.classList.remove('pdp-ux-swatch-dimmed');
    } else {
      el.classList.add('pdp-ux-swatch-dimmed');
    }
  });
}

function applyColorDimming(selectedBody, selectedFingerboard) {
  colorLabels.forEach(el => {
    const mapColor = colorMap[el.title];
    const hasBody = mapColor.body == selectedBody;
    const hasFingerboard = mapColor.fingerboards.includes(selectedFingerboard);

    if (hasBody && hasFingerboard) {
      el.classList.remove('pdp-ux-swatch-dimmed');
    } else {
      el.classList.add('pdp-ux-swatch-dimmed');
    }
  });
}

function updateSwatchPortraits(selectedFingerboard) {
  if (fingerboardImageMap[selectedFingerboard]) {
    colorLabels.forEach(el => {
      const newUrl = fingerboardImageMap[selectedFingerboard][el.title];
      if (newUrl) {
        const portraitEl = el.querySelector('span.swatch--portrait');
        if (portraitEl) {
          portraitEl.style = `--swatch--background: url(${fingerboardImageMap[selectedFingerboard][el.title]}); --box--diagonal--size: 103.22790320451152px; --swatch-rotation: 54.46232220802562deg;`;
        }
      }
    });
  }
}

function getAvailableFinishCount(body, fingerboard) {
  let count = 0;

  Object.keys(colorMap).forEach(color => {
    if (colorMap[color].body == body && colorMap[color].fingerboards.includes(fingerboard)) {
      count += 1;
    }
  });

  return count;
}

// If there are less colors availble for these materials than the total amount for the product, populate the finish count span.
function handleFinishCount(body, fingerboard) {
  let availableFinishes = 0;
  Object.keys(colorMap).forEach(color => {
    if (colorMap[color].body == body && colorMap[color].fingerboards.includes(fingerboard)) {
      availableFinishes += 1;
    }
  });

  if (availableFinishes < colorInputs.length) {
    const translationType = (availableFinishes == 1) ? 'single' : 'multiple';
    let translatedText = finishCountTranslations[translationType][currentLocale];
    translatedText = (availableFinishes > 1) ? translatedText.replace('#', availableFinishes) : translatedText;
    // Polish has a different translation for 2-4 than for 5 and above.
    if (Shopify.locale == 'pl' && availableFinishes >= 5) {
      translatedText = translatedText.replace('wykończenia', 'wykończeń');
    }
    finishCountEl.innerHTML = `(${translatedText})`;
  }
}

// On color option select.
colorInputs.forEach(el => {
  el.addEventListener('change', event => {
    if (event.target.checked) {
      const selectedColor = colorMap[event.target.value];
      if (!selectedColor) return;

      //
      // Apply dimming to materials based on availability.
      //
      applyBodyMaterialDimming(selectedColor.body);
      applyFingerboardMaterialDimming(event.target.value);

      // 
      // Select the first available material option (if not already checked)
      //
      let selectedBody;
      const checkedBodyEl = document.querySelector('input[name="Body Material"]:checked');
      if (selectedColor.body != checkedBodyEl.value) {
        let availableBodyFound = false;
        bodyMaterialInputs.forEach(el => {
          if (!availableBodyFound && selectedColor.body.includes(el.value)) {
            el.checked = true;
            availableBodyFound = true;
            selectedBody = el.value;
          }
        });
      } else {
        selectedBody = checkedBodyEl.value;
      }

      let selectedFingerboard;
      const checkedFingerboardEl = document.querySelector('input[name="Fingerboard Material"]:checked');
      if (!selectedColor.fingerboards.includes(checkedFingerboardEl.value)) { 
        let availableFingerboardFound = false;
        fingerboardMaterialInputs.forEach(el => {
          if (!availableFingerboardFound && selectedColor.fingerboards.includes(el.value)) {
            el.checked = true;
            availableFingerboardFound = true;
            selectedFingerboard = el.value;
          }
        });
      } else {
        selectedFingerboard = checkedFingerboardEl.value;
      }

      // Apply diming to other colors based on selected material values.
      applyColorDimming(selectedBody, selectedFingerboard);
      updateSwatchPortraits(selectedFingerboard);
      // Remove the finish count text
      finishCountEl.innerHTML = '';
    }
  });
});

// On body material option select.
bodyMaterialInputs.forEach(el => {
  el.addEventListener('change', function (event) {
    if (event.target.checked) {
      const selectedBody = event.target.value;
      // Get selected fingerboard - both are needed for color dimming
      const checkedFingerboardEl = document.querySelector('input[name="Fingerboard Material"]:checked');
      const selectedFingerboard = checkedFingerboardEl.value;
      const availableColors = getAvailableColors(selectedBody, selectedFingerboard);
      // Apply diming to colors based on availability.
      colorLabels.forEach(el => {
        if (availableColors.includes(el.title)) {
          el.classList.remove('pdp-ux-swatch-dimmed');
        } else {
          el.classList.add('pdp-ux-swatch-dimmed');
        }
      });
      // Select the first available color option if the current is unavilable
      let selectedColor;
      const checkedColorEl = document.querySelector('input[name="Color"]:checked');
      if (!availableColors.includes(checkedColorEl.value)) {
        let availableColorFound = false;
        colorInputs.forEach(el => {
          if (!availableColorFound && availableColors.includes(el.value)) {
            el.checked = true;
            availableColorFound = true;
            selectedColor = el.value;
          }
        });
      } else {
        selectedColor = checkedColorEl.value;
      }

      applyBodyMaterialDimming(selectedBody);
      applyFingerboardMaterialDimming(selectedColor);
      updateSwatchPortraits(selectedFingerboard);
      handleFinishCount(selectedBody, selectedFingerboard);
    }
  });
});

// On fingerboard material option select.
fingerboardMaterialInputs.forEach(el => {
  el.addEventListener('change', function (event) {
    if (event.target.checked) {
      const selectedFingerboard = event.target.value;
      // Get selected body - both are needed for color dimming
      const checkedBodyEl = document.querySelector('input[name="Body Material"]:checked');
      const selectedBody = checkedBodyEl.value;
      const availableColors = getAvailableColors(selectedBody, selectedFingerboard);
      // Apply diming to colors based on availability.
      colorLabels.forEach(el => {
        if (availableColors.includes(el.title)) {
          el.classList.remove('pdp-ux-swatch-dimmed');
        } else {
          el.classList.add('pdp-ux-swatch-dimmed');
        }
      });

      let selectedColor;
      // Select the first available color option if the current is unavilable
      const checkedColorEl = document.querySelector('input[name="Color"]:checked');
      if (!availableColors.includes(checkedColorEl.value)) {
        let availableColorFound = false;
        colorInputs.forEach(el => {
          if (!availableColorFound && availableColors.includes(el.value)) {
            el.checked = true;
            selectedColor = el.value;
            availableColorFound = true;
          }
        });
      } else {
        selectedColor = checkedColorEl.value;
      }

      applyFingerboardMaterialDimming(selectedColor);
      updateSwatchPortraits(selectedFingerboard);
      handleFinishCount(selectedBody, selectedFingerboard);
    }
  });
});

// On load
const checkedColorEl = document.querySelector('input[name="Color"]:checked');
const checkedBodyEl = document.querySelector('input[name="Body Material"]:checked');
const checkedFingerboardEl = document.querySelector('input[name="Fingerboard Material"]:checked');

applyBodyMaterialDimming(checkedBodyEl.value);
applyFingerboardMaterialDimming(checkedColorEl.value);
applyColorDimming(checkedBodyEl.value, checkedFingerboardEl.value);
updateSwatchPortraits(checkedFingerboardEl.value);